<div class="sm:hidden mx:block" style="background: white; padding: 0 2rem;">
    <customer-select class="customer-selector" style="display: flex; justify-content: end; background: white;
        border-bottom: 1px solid black;"></customer-select>
</div>
<div class="work-shop-page">
	<!-- Filter Bar -->
	<section class="filter-bar">
		<div class="filter-bar__search">
			<div class="filter-bar__search-input">
				<input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()" placeholder="搜索维修站ID、名称或大区..." class="filter-bar__input" />
			</div>
			<button class="filter-bar__search-icon-btn" *ngIf="searchText" (click)="clearSearchText()">
				<i nz-icon nzType="close" nzTheme="outline"></i>
			</button>
			<button class="filter-bar__search-icon-btn" (click)="onSearch()">
				<i nz-icon nzType="search" nzTheme="outline"></i>
			</button>
		</div>
		<div class="filter-bar__dropdowns">
			<nz-select class="filter-bar__dropdown"
				[nzPlaceHolder]="'年份'"
				[(ngModel)]="selectedYear"
				(ngModelChange)="onYearChange($event)">
				<nz-option *ngFor="let year of yearOptions" [nzLabel]="year" [nzValue]="year"></nz-option>
			</nz-select>
			<nz-select class="filter-bar__dropdown"
				[nzPlaceHolder]="'月份'"
				[(ngModel)]="selectedMonth"
				nzMode="multiple"
				[nzAllowClear]="true"
				[nzShowArrow]="true"
				[nzMaxTagCount]="1"
				[nzDropdownRender]="monthSelectFooter"
				(ngModelChange)="onFilterChange()">
				<nz-option *ngFor="let month of monthOptions" [nzLabel]="month" [nzValue]="month"></nz-option>
			</nz-select>
			<ng-template #monthSelectFooter>
				<div class="filter-bar__select-footer" (mousedown)="$event.preventDefault()">
					<button type="button" class="filter-bar__select-footer-btn" (click)="toggleSelectAll('month')">
						{{ isAllSelected(selectedMonth, monthOptions) ? '取消全选' : '全选' }}
					</button>
				</div>
			</ng-template>
			<nz-select class="filter-bar__dropdown"
				[nzPlaceHolder]="'产品线'"
				[(ngModel)]="selectedCbfName"
				nzMode="multiple"
				[nzAllowClear]="true"
				[nzShowArrow]="true"
				[nzMaxTagCount]="1"
				[nzDropdownRender]="cbfNameSelectFooter"
				(ngModelChange)="onFilterChange()">
				<nz-option *ngFor="let cbfName of cbfNameOptions" [nzLabel]="cbfName" [nzValue]="cbfName"></nz-option>
			</nz-select>
			<ng-template #cbfNameSelectFooter>
				<div class="filter-bar__select-footer" (mousedown)="$event.preventDefault()">
					<button type="button" class="filter-bar__select-footer-btn" (click)="toggleSelectAll('cbfName')">
						{{ isAllSelected(selectedCbfName, cbfNameOptions) ? '取消全选' : '全选' }}
					</button>
				</div>
			</ng-template>
			<nz-select class="filter-bar__dropdown"
				[nzPlaceHolder]="'维修站类型'"
				[(ngModel)]="selectedWorkshopType"
				nzMode="multiple"
				[nzAllowClear]="true"
				[nzShowArrow]="true"
				[nzMaxTagCount]="1"
				[nzDropdownRender]="workshopTypeSelectFooter"
				(ngModelChange)="onFilterChange()">
				<nz-option *ngFor="let workshopType of workshopTypeOptions" [nzLabel]="workshopType" [nzValue]="workshopType"></nz-option>
			</nz-select>
			<ng-template #workshopTypeSelectFooter>
				<div class="filter-bar__select-footer" (mousedown)="$event.preventDefault()">
					<button type="button" class="filter-bar__select-footer-btn" (click)="toggleSelectAll('workshopType')">
						{{ isAllSelected(selectedWorkshopType, workshopTypeOptions) ? '取消全选' : '全选' }}
					</button>
				</div>
			</ng-template>
		</div>
		<div class="filter-bar__divider"></div>
		<button class="filter-bar__clear-btn" (click)="clearFilters()">
			<i nz-icon nzType="delete" nzTheme="outline"></i>
			<span>清除</span>
		</button>
	</section>

	<!-- Summary Cards -->
	<section class="summary-cards">
		<!-- 维修站状态概览 -->
		<div class="summary-card summary-card--status">
			<nz-spin [nzSpinning]="statusOverviewLoading" nzTip="加载中...">
				<div class="summary-card__header-row">
					<h3 class="summary-card__label">维修站状态概览</h3>
				</div>
				<div class="status-metrics">
					<div class="status-metric">
						<span class="status-metric__label">活跃</span>
						<span class="status-metric__value status-metric__value--active">{{ statusOverview.active }}</span>
					</div>
					<div class="status-metric">
						<span class="status-metric__label">新建</span>
						<span class="status-metric__value status-metric__value--new">{{ statusOverview.new }}</span>
					</div>
					<div class="status-metric">
						<span class="status-metric__label">冻结</span>
						<span class="status-metric__value status-metric__value--frozen">{{ statusOverview.frozen }}</span>
					</div>
				</div>
				<div class="status-bar">
					<div class="status-bar__segment status-bar__segment--active" [style.width]="statusBarWidths.active">
					</div>
					<div class="status-bar__segment status-bar__segment--new" [style.width]="statusBarWidths.new"></div>
					<div class="status-bar__segment status-bar__segment--frozen" [style.width]="statusBarWidths.frozen">
					</div>
				</div>
				<p class="summary-card__footer-text">总计: {{ statusOverview.total }} 个维修站</p>
			</nz-spin>
		</div>

		<!-- 最近7天兑换 -->
		<div class="summary-card summary-card--redemption">
			<nz-spin [nzSpinning]="redemptionLoading" nzTip="加载中...">
				<div class="summary-card--redemption__left">
					<h3 class="summary-card__label">最近7天兑换</h3>
					<div class="redemption-content">
						<div class="redemption-icon">
							<i nz-icon nzType="flag" nzTheme="outline"></i>
						</div>
						<div class="redemption-data">
							<span class="redemption-data__count">{{ redemptionSummary.count }}</span>
							<div class="redemption-data__trend"
								[class.redemption-data__trend--up]="!redemptionSummary.trendFlat && redemptionSummary.trendUp"
								[class.redemption-data__trend--down]="!redemptionSummary.trendFlat && !redemptionSummary.trendUp"
								[class.redemption-data__trend--flat]="redemptionSummary.trendFlat">
								<i nz-icon
									[nzType]="redemptionSummary.trendFlat ? 'minus' : (redemptionSummary.trendUp ? 'rise' : 'fall')"
									nzTheme="outline"></i>
								<span>{{ redemptionSummary.trendPercent }}%</span>
							</div>
						</div>
					</div>
					<p class="redemption-desc">{{ redemptionSummary.description }}</p>
				</div>
			</nz-spin>
		</div>

		<!-- 各类型维修站业绩达成 -->
		<div class="summary-card summary-card--performance summary-card--performance-types"
			*ngIf="!workshopTypeLoaded || workshopTypePerformance?.length">
			<nz-spin [nzSpinning]="workshopTypeLoading" nzTip="加载中...">
				<h3 class="summary-card__label" [style.visibility]="workshopTypeLoading ? 'hidden' : 'visible'">各类型维修站业绩达成</h3>
				<div class="perf-grid perf-grid--three-columns">
					<div class="perf-item" *ngFor="let item of workshopTypePerformance"
						[style.border-left-color]="item.color">
						<div class="perf-item__header">
							<span class="perf-item__type" [style.background-color]="item.bgColor">{{ item.type }}</span>
							<span class="perf-item__target">目标: {{ item.target }}</span>
						</div>
						<div class="perf-item__values">
							<span class="perf-item__achieved">{{ item.achieved }}</span>
							<span class="perf-item__total"> / {{ item.total }}</span>
							<span class="perf-item__unit">{{ item.unit }}</span>
						</div>
						<div class="perf-item__bar">
							<div class="perf-item__bar-bg">
								<div class="perf-item__bar-fill" [style.width.%]="item.percent"
									[style.background-color]="item.color"></div>
							</div>
							<span class="perf-item__percent" [style.color]="item.color">{{ item.percent }}%</span>
						</div>
					</div>
				</div>
			</nz-spin>
		</div>

		<!-- 销售店业绩达成 -->
		<div class="summary-card summary-card--performance summary-card--performance-sales"
			*ngIf="!salesStoreLoaded || salesStorePerformance?.length">
			<nz-spin [nzSpinning]="salesStoreLoading" nzTip="加载中...">
				<h3 class="summary-card__label" [style.visibility]="salesStoreLoading ? 'hidden' : 'visible'">销售店业绩达成</h3>
				<div class="perf-grid perf-grid--single-column">
					<div class="perf-item" *ngFor="let item of salesStorePerformance"
						[style.border-left-color]="item.color">
						<div class="perf-item__header">
							<span class="perf-item__type" [style.background-color]="item.bgColor">{{ item.type }}</span>
							<span class="perf-item__target">目标: {{ item.target }}</span>
						</div>
						<div class="perf-item__values">
							<span class="perf-item__achieved">{{ item.achieved }}</span>
							<span class="perf-item__total"> / {{ item.total }}</span>
							<span class="perf-item__unit">{{ item.unit }}</span>
						</div>
						<div class="perf-item__bar">
							<div class="perf-item__bar-bg">
								<div class="perf-item__bar-fill" [style.width.%]="item.percent"
									[style.background-color]="item.color"></div>
							</div>
							<span class="perf-item__percent" [style.color]="item.color">{{ item.percent }}%</span>
						</div>
					</div>
				</div>
			</nz-spin>
		</div>
	</section>

	<!-- 维修站主数据 -->
	<section class="main-data">
		<div class="main-data__header">
			<div class="section-heading">
				<div class="section-heading__bar"></div>
				<h2 class="section-heading__title">维修站主数据 (精细化明细)</h2>
			</div>
			<button type="button" class="main-data__download-btn" [disabled]="masterDataExportLoading"
				(click)="onDownloadMasterData()">
				<i nz-icon [nzType]="masterDataExportLoading ? 'loading' : 'download'" nzTheme="outline"></i>
				<span>{{ masterDataExportLoading ? '下载中...' : '下载' }}</span>
			</button>
		</div>

		<div class="main-data__content">
			<!-- Table -->
			<div class="data-table-wrapper">
				<nz-spin [nzSpinning]="workshopTableLoading" nzTip="加载中...">
					<table class="data-table">
						<thead>
							<tr>
								<th class="data-table__th" style="width: 80px;">ID/类型</th>
								<th class="data-table__th" style="width: 138px;">维修站名称</th>
								<th class="data-table__th" style="width: 45px;">大区</th>
								<th class="data-table__th" style="width: 164px;">详细地址</th>
								<th class="data-table__th" style="width: 70px;">状态</th>
								<th class="data-table__th data-table__th--center" style="width: 53px;">积分</th>
								<th class="data-table__th data-table__th--center" style="width: 81px;">最近兑换</th>
								<th class="data-table__th data-table__th--center" style="width: 91px;">操作</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let row of pagedWorkshopRows" class="data-table__row"
								[class.data-table__row--selected]="row.selected">
								<td class="data-table__td data-table__td--id">
									<span class="data-table__id" [class.data-table__id--selected]="row.selected">{{ row.id }}</span>
									<span class="data-table__type-tag" [style.border-color]="row.typeColor"
										[style.color]="row.typeColor">{{ row.type }}</span>
								</td>
								<td class="data-table__td">
									<span class="data-table__name">{{ row.name }}</span>
								</td>
								<td class="data-table__td">{{ row.region }}</td>
								<td class="data-table__td data-table__td--address">{{ row.address }}</td>
								<td class="data-table__td">
									<span class="data-table__status" [style.background-color]="row.statusColor">{{ row.status }}</span>
								</td>
								<td class="data-table__td data-table__td--center">
									<span class="data-table__points" [style.color]="row.pointsColor">{{ formatPoints(row.points) }}</span>
								</td>
								<td class="data-table__td data-table__td--center data-table__td--date">{{ row.lastRedemption }}</td>
								<td class="data-table__td data-table__td--center">
									<button class="data-table__action-btn"
										[class.data-table__action-btn--primary]="row.selected"
										(click)="onDetailClick(row)">达成明细</button>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="data-table__footer">
						<span class="data-table__record-count">共 {{ totalRecords }} 条记录</span>
						<div class="data-table__pagination">
							<nz-pagination [nzPageIndex]="currentPage" [nzPageSize]="pageSize" [nzTotal]="totalRecords"
								[nzShowSizeChanger]="false" (nzPageIndexChange)="onPageChange($event)"></nz-pagination>
						</div>
					</div>
				</nz-spin>
			</div>

			<!-- Sidebar -->
			<div class="data-sidebar">
				<div class="sidebar-card">
					<nz-spin [nzSpinning]="performanceLoading" nzTip="加载中...">
						<div class="sidebar-card__header">
							<h3 class="sidebar-card__title">维修站绩效分布</h3>
						</div>

						<div class="perf-distribution">
							<div class="perf-distribution__item" *ngFor="let dist of performanceDistributions">
								<div class="perf-distribution__label-row">
									<span class="perf-distribution__label">{{ dist.label }}</span>
									<span class="perf-distribution__value">{{ (dist.value * 100) | number:'1.1-1' }}%</span>
								</div>
								<div class="perf-distribution__bar">
									<div class="perf-distribution__bar-fill" [style.width.%]="dist.value * 100"></div>
								</div>
							</div>
						</div>

						<div class="top-performers">
							<h4 class="top-performers__title">区域业绩之星 (TOP 4)</h4>
							<div class="top-performers__list">
								<div class="top-performer" *ngFor="let performer of topPerformers">
									<span class="top-performer__rank" [style.background-color]="performer.rankBgColor"
										[style.color]="performer.rankTextColor">{{ performer.rank }}</span>
									<span class="top-performer__name">{{ performer.name }}</span>
									<span class="top-performer__amount">{{ performer.amount }}</span>
								</div>
							</div>
						</div>
					</nz-spin>
				</div>
			</div>
		</div>
	</section>

	<!-- 选中维修站产品线达成汇总 -->
	<section class="product-summary">
		<div class="section-heading">
			<div class="section-heading__bar"></div>
			<h2 class="section-heading__title">
				维修站产品线达成汇总
			</h2>
		</div>

		<div class="product-table-wrapper">
			<nz-spin [nzSpinning]="productLineLoading" nzTip="加载中...">
				<div class="product-table__info-bar">
					<ng-container *ngIf="selectedWorkshop; else allWorkshopsTitle">
						<span class="product-table__info-title">
							统计明细: {{ selectedWorkshop.name }} ({{ selectedWorkshop.id }})
						</span>
						<button type="button" class="product-table__cancel-btn" (click)="onCancelDetail()">
							<i nz-icon nzType="close" nzTheme="outline"></i>
							<span>取消</span>
						</button>
					</ng-container>
					<ng-template #allWorkshopsTitle>
						<span class="product-table__info-title">统计明细: 全量维度展示</span>
					</ng-template>
				</div>
				<table class="product-table">
					<thead>
						<tr>
							<th class="product-table__th">维修站ID</th>
							<th class="product-table__th">维修站名称</th>
							<th class="product-table__th">产品线</th>
							<th class="product-table__th">产品线名称</th>
							<th class="product-table__th product-table__th--right">采购数量</th>
							<th class="product-table__th product-table__th--right">销售金额</th>
							<th class="product-table__th product-table__th--center">同比增长</th>
							<th class="product-table__th product-table__th--center">环比增长</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of productLineRows" class="product-table__row">
							<td class="product-table__td">{{ row.workshopId }}</td>
							<td class="product-table__td product-table__td--name">{{ row.workshopName }}</td>
							<td class="product-table__td">
								<div class="product-line-cell">
									<span class="product-line-cell__dot"
										[style.background-color]="row.productLineColor"></span>
									<span>{{ row.productLine }}</span>
								</div>
							</td>
							<td class="product-table__td">{{ row.cbfCNName }}</td>
							<td class="product-table__td product-table__td--right">{{ row.quantity }}</td>
							<td class="product-table__td product-table__td--right product-table__td--bold">{{ row.salesAmount }}</td>
							<td class="product-table__td product-table__td--center">
								<span *ngIf="row.yoyAvailable; else yoyEmpty" class="growth-badge"
									[class.growth-badge--up]="row.yoyUp" [class.growth-badge--down]="!row.yoyUp">
									<i nz-icon [nzType]="row.yoyUp ? 'caret-up' : 'caret-down'" nzTheme="outline"></i>
									{{ row.yoyGrowth }}
								</span>
								<ng-template #yoyEmpty>
									<span class="growth-badge growth-badge--empty">{{ row.yoyGrowth }}</span>
								</ng-template>
							</td>
							<td class="product-table__td product-table__td--center">
								<span *ngIf="row.momAvailable; else momEmpty" class="growth-badge"
									[class.growth-badge--up]="row.momUp" [class.growth-badge--down]="!row.momUp">
									<i nz-icon [nzType]="row.momUp ? 'caret-up' : 'caret-down'" nzTheme="outline"></i>
									{{ row.momGrowth }}
								</span>
								<ng-template #momEmpty>
									<span class="growth-badge growth-badge--empty">{{ row.momGrowth }}</span>
								</ng-template>
							</td>
						</tr>
						<tr *ngIf="!productLineRows.length">
							<td class="product-table__td product-table__td--center" colspan="7">
								暂无数据
							</td>
						</tr>
					</tbody>
				</table>
				<div class="data-table__footer" *ngIf="productTotalRecords > 0">
					<span class="data-table__record-count">共 {{ productTotalRecords }} 条记录</span>
					<div class="data-table__pagination">
						<nz-pagination [nzPageIndex]="productCurrentPage" [nzPageSize]="productPageSize"
							[nzTotal]="productTotalRecords" [nzShowSizeChanger]="false"
							(nzPageIndexChange)="onProductPageChange($event)"></nz-pagination>
					</div>
				</div>
			</nz-spin>
		</div>
	</section>
</div>